import { View } from './view'

export const OpennessAndResponsibility = View
